"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trommelkern = void 0;
var Trommelkern;
(function (Trommelkern) {
    Trommelkern["festpunkt"] = "festpunkt";
    Trommelkern["mitnehmer"] = "mitnehmer";
})(Trommelkern = exports.Trommelkern || (exports.Trommelkern = {}));
//# sourceMappingURL=TrommelModel.js.map